
    import Vue from 'vue';
    import { defineComponent } from 'vue';
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import genericModulePlanService from '@/apps/shared/services/getGenericModulePlan-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        components: {
            XBreadcrumb,
            WhatsApp
        },
        data() {
            return {
                PlanJson: null,
                premioMensual: null,
                coberturas: [],
                Plandata: [],
                selectedPlan: null,
                finallyCalculationResult: [],
                plansLength: null,
                plans: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/Integro-Max' },
                    { text: 'Datos de la Persona que contrata', path: '/Integro-Max/DatosContratante' },
                    { text: 'Datos de que quieres contratar', path: '/Integro-Max/DatosVigencia' },
                    { text: 'Elegi un Plan', path: '/Integro-Max/Planes' },
                ],
                leadId: null,
                genericModulePlans: [],
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {
            selectedPlans: function (quotationData) {                
                var pricingId = parseInt(quotationData.pricingId)
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        sessionStorage.setItem("ExitOrContinueModal", "false")
                        window.location.href = '../Integro-Max/Contratante';
                    }
                    else {
                        const eventData = {
                            'pas': this.pas,
                            'email': this.email,
                            'product': 'apintegro',
                            'event': 'errorServidor',
                            'paso': 'cotizador-apintegro-plan',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'integro-max-tab-three',
                })
            },

            open: function () {
                this.$refs.modal.open();
            },

            close: function () {
                this.$refs.modal.close();
            },

            dataPlans: function () {
                var PlanData = sessionStorage.getItem("quotationData");

                if (PlanData != null) {

                    this.PlanJson = JSON.parse(PlanData);

                    const Planes = this.PlanJson.reduce((result, plan, index) => {
                        const rank = plan.rank16To70;
                        const planName = `Opción ${index + 1}`;

                        const premioSinDesc = plan.premioSinDescuento != null ? Number(plan.premioSinDescuento) : null;
                        const premioConDesc = Number(rank.premioMensual);
                        const rate = plan.descuentoRate != null ? Number(plan.descuentoRate) : null;

                        const hasDiscount = !!(rate && premioSinDesc && premioSinDesc > premioConDesc);

                        result[planName] = {
                            PlanName: planName,
                            relationQuotationId: plan.relationQuotationId,
                            pricingId: rank.pricingId,
                            hasDiscount,
                            rate: plan.descuentoRate,
                            premiumWithoutDiscount: plan.premioSinDescuento.toLocaleString('de-DE'),
                            premioMensual: rank.premioMensual.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }),
                            premioSegunVigencia: rank.premioSegunVigencia.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }),
                            basesImponibles: rank.basesImponibles.map((base) => ({
                                ivaMensual: base.ivaMensual,
                                ivaSegunVigencia: base.ivaSegunVigencia,
                            })),
                            calculosFinales: rank.finallyCalculationResult
                                .sort((a, b) => a.detalleInt - b.detalleInt)  // Evitamos que se desordenen coberturas)
                                .map((detalle) => ({
                                    descripcion: detalle.descripcion,
                                    primaMensual: detalle.primaMensual.toLocaleString('de-DE', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    }),
                                    primaSegunVigencia: detalle.primaSegunVigencia.toLocaleString('de-DE', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    }),
                                    capital: detalle.capital,
                                    tipoDetalle: detalle.tipoDetalle,
                                    detalleInt: detalle.detalleInt
                                })),
                        };

                        return result;
                    }, {});

                    this.plans = Planes;
                    this.plansLength = Object.keys(Planes).length;
                }
            },

            // Busca la cobertura genérica de LAD para AP.
            GetGenericModulePlan: function () {
                var productId = 711;
                genericModulePlanService.getGenericModulePlans(productId).then(response => {
                    this.genericModulePlans = response;
                    this.genericModulePlans = this.genericModulePlans.filter(o => o.planCode == 1 || o.planCode == 2)
                });
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAPIntegroGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            formatDate(dateString: string) {
                dateString = dateString.replace(/"/g, ""); 
                const [year, month, day] = dateString
                    .split('T')[0]
                    .split('-');
                return `${day}/${month}/${year}`;
            },

            async pageCustomization() {
                const defaultTitle = 'Íntegro Max';
                const actualStep = 'quoted';
                const actualPath = '/ap-24-hs';
                var tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                var tabTwoData = JSON.parse(sessionStorage.getItem("TabTwoData"));
                var vigencyStart = this.formatDate(sessionStorage.getItem("vigencyStart"));
                var vigencyEnd = this.formatDate(sessionStorage.getItem("vigencyEnd"));
                var peopleToCover = sessionStorage.getItem("peopleToCover");
                var quotaQuantity = JSON.parse(sessionStorage.getItem("quotaQuantity"));
                var tipoDePersona = tabTwoData.personType == 0 ? "Fisica" : "Juridica";
                var formaDePago = quotaQuantity == "0" ? "Pago mensual" : "Pago único";

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = tabOneWelcome.lastName;
                request.phone = tabOneWelcome.areaCode + tabOneWelcome.telephone;
                request.mail = tabOneWelcome.email;
                request.quotationDetail =
                    "Producto: " + defaultTitle +
                    " - Localidad: " + tabOneWelcome.selectedLocality.zipCode +
                    " - Nombre Localidad: " + tabOneWelcome.selectedLocality.text +
                    " - Actividad: " + tabTwoData.selectedActivity.activityDescription +
                    " - Tipo de persona: " + tipoDePersona +
                    " - Condición fiscal: " + tabTwoData.fiscalConditionName +
                    " - Vigencia desde: " + vigencyStart +
                    " - Vigencia hasta: " + vigencyEnd +
                    " - Personas a cubrir: " + peopleToCover +
                    " - Forma de pago: " + formaDePago;
                request.quotePlan = (Object.values(this.plans) as Array<{ PlanName: string }>)
                    .map(p => p.PlanName)
                    .join(' - ');

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
        },
        mounted() {           
            this.dataPlans();
            this.GetGenericModulePlan();

            const parallelPromises = [
                this.pageCustomization(),
                this.updateByProductGoogleAnalytics()
            ];

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            this.peopleToCover = sessionStorage.getItem("peopleToCover");
            this.email = JSON.parse(sessionStorage.getItem("TabOneWelcome")).email

            const eventData = {
                'pas': this.pas,
                'email': this.email,
                'product': 'apintegro',
                'event': 'cotizador-apintegro-plan',
                'personas': this.peopleToCover,
                'referente': this.referente,
                'medio': this.medium
            };

            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push(eventData);

            const customWindow = window as typeof window & {
                _qsie?: Array<typeof eventData>;
            };

            customWindow._qsie ??= [];
            customWindow._qsie.push(eventData);
        }
    })
